import { useState } from 'react';
import { useDeepCompareEffect } from 'ahooks';

import type { ILegendSelectedChangePayload } from '../LineChart';

const getLegendSelectedBySeries = (series?: IEChartOption['series']): Record<string, boolean> => {
  if (!Array.isArray(series) || series.length === 0) return {};
  return series
    .map((serie) => serie?.name)
    .reduce((acc, cur) => {
      if (!cur) return acc;
      return { ...acc, [cur]: true };
    }, {});
};

export default function useLegendSelected(series?: IEChartOption['series']) {
  const [legendSelected, setLegendSelected] = useState<Record<string, boolean>>({});

  const handleLegendSelectedChange = (payload: ILegendSelectedChangePayload) => {
    const legendSelectedTmp = payload?.selected || legendSelected;
    setLegendSelected(legendSelectedTmp);
  };

  useDeepCompareEffect(() => {
    const legendSelectedTmp = getLegendSelectedBySeries(series);

    setLegendSelected(legendSelectedTmp);
  }, [series]);

  return { legendSelected, onLegendSelectedChange: handleLegendSelectedChange };
}
